import { CampaignPage } from "./CampaignPage";

const Campaign = () => {
	return <CampaignPage />;
};
export default Campaign;
